import { render } from "./FieldTable.vue?vue&type=template&id=acb460b2&scoped=true"
import script from "./FieldTable.vue?vue&type=script&lang=js"
export * from "./FieldTable.vue?vue&type=script&lang=js"

import "./FieldTable.vue?vue&type=style&index=0&id=acb460b2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb460b2"]])

export default __exports__